import { SIZES } from 'common/constants/sizes';
import styled from 'styled-components';

export const StyledEmptyStateContent = styled.div`
  display: flex;
  justify-content: center;
  width: auto;
  & > main {
    text-align: left;
    width: 20%;
    margin-left: 1rem;
    margin-top: 3.5rem;
    & > .primary {
      font-size: ${SIZES['x-large']};
      margin: 1rem 0;
    }
    & > .secondary {
      font-size: ${SIZES.medium};
    }
  }
`;

export const StyledEmptyState = styled.div`
  height: 95%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;
